import "@/assets/iconfont/index";
import "@/permission";
// 本地SVG图标
import "virtual:svg-icons-register";
// 国际化
// import i18n from "@/lang/index";
// 样式
import "element-plus/theme-chalk/dark/css-vars.css";
import "@/styles/index.scss";
import "uno.css";
import "element-plus/theme-chalk/el-loading.css";

import { BrowserTracing } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import { createApp } from "vue";

import { setupDirective } from "@/directive";
import router from "@/router";
import { env } from "@/settings";
import { setupStore } from "@/store";

import App from "./App.vue";

const { isTest, isDev } = env;
const isProd = !isDev && !isTest;
const app = createApp(App);
// 全局注册 自定义指令(directive)
setupDirective(app);
// 全局注册 状态管理(store)
setupStore(app);

app.use(router).mount("#app");
const isRunTime = process.env.NODE_ENV === "development";
const testEnv = isTest ? "test" : "dev";
Sentry.init({
  app,
  dsn: "https://26cad36cd1a2463081016ccc394cffb0@sentry.woordee.com/14",
  integrations: [
    new Sentry.Integrations.Breadcrumbs({ console: !isRunTime }),
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "my-site-url.com", /^\//],
    }),
    new Sentry.Integrations.Breadcrumbs({ console: !isRunTime }),
  ],
  tracesSampleRate: 1.0,
  environment: isProd ? "prod" : testEnv,
  logErrors: !isProd,
});
